(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coveo-search-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          const el = document.getElementById(url.hash.slice(1));
          if (el) el.scrollIntoView({ behavior: 'instant' });
        },
        { once: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sitemap-dynamic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const categoriesColumn = document.querySelector('.sitemap-column--categories');

    const toggleButton = categoriesColumn?.querySelector('.sitemap-toggle');

    if (!categoriesColumn || !toggleButton) {
      return;
    }

    const icon = toggleButton.querySelector('.sitemap-toggle__icon');
    const text = toggleButton.querySelector('.sitemap-toggle__text');

    toggleButton.addEventListener('click', () => {
      const isExpanded = categoriesColumn.classList.toggle('is-expanded');

      toggleButton.setAttribute('aria-expanded', String(isExpanded));

      if (isExpanded) {
        icon.textContent = '−';
        text.textContent = 'Show Less';
      } else {
        icon.textContent = '+';
        text.textContent = 'Show More';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
